import 'whatwg-fetch';
import { camelizeKeys } from 'humps';

import Sample from 'src/models/Sample';
import Reaction from 'src/models/Reaction';

export default class UIFetcher {
  static initialize() {
    const promise = fetch('/api/v1/ui/initialize', {
      credentials: 'same-origin',
    }).then(response => response.json())
      .then(json => camelizeKeys(json))
      .catch(err => console.log(err)); // eslint-disable-line

    return promise;
  }

  static deleteElementsByUIState(params) {
    return fetch('/api/v1/ui_state/', {
      credentials: 'same-origin',
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(params)
    }).then(response => response.json())
      .then((json) => {
        return json;
      })
      .catch((errorMessage) => { console.log(errorMessage); });
  }

  static loadReport(params, loadType) {
    const tParams = Object.assign({}, params, { loadType });

    return fetch('/api/v1/ui_state/load_report', {
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(tParams),
    }).then(response => response.json())
      .then((json) => {
        const samples = json.samples.map(s => new Sample(s));
        const reactions = json.reactions.map(r => new Reaction(r));
        return { samples, reactions };
      })
      .catch((errorMessage) => { console.log(errorMessage); });
  }

  static fetchNMRDisplayerHost() {
    return fetch('/api/v1/chemspectra/nmrium_wrapper/host_name', {
      credentials: 'same-origin',
      method: 'GET',
    }).then((response) => {
      return response.json();
    }).then((json) => {
      return json;
    }).catch((errorMessage) => {
      console.log(errorMessage);
    });
  }
}
